<template>
  <div class="purchase-order-list">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :count='count'
      :current="page"

    >
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem" v-if="roleType!==2">
            <label>门店名称:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <goodsSearchItem v-model="query.nameMix"></goodsSearchItem>
            <!-- <label>商品:</label>
            <lk-input clearable v-model='query.nameMix' class="item" placeholder="商品名称、通用名称、助记码、商品编码"></lk-input> -->
          </div>
          <div class="queryItem">
            <label>采购订单号:</label>
            <lk-input clearable v-model='query.code' class="item" placeholder="请输入"></lk-input>
          </div>
          <div class="queryItem">
            <label>商品类型:</label>
            <lk-select v-model='query.goodsType' class="item" clearable>
              <lk-option v-for="(item, index) in getNormalGoodsTypes" :key="index" :value="item.value">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>来源:</label>
            <lk-select v-model='query.purchaseType' class="item" clearable>
              <lk-option v-for="(item, index) in getGoodsOrigin" :key="index" :value="item.value">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>创建时间:</label>
            <timeStampDatePicker v-model='query.createTimeStart' class="item"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>至</label>
            <timeStampDatePicker v-model='query.createTimeEnd' class="item"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>创建人:</label>
            <lk-input clearable v-model='query.createUserName' class="item"></lk-input>
          </div>
          <div class="queryItem">
            <label>订单状态:</label>
            <lk-select v-model='query.status' class="item">
              <lk-option v-for="(item, index) in orderStatus" :key="index" :value="index+1">{{item}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>供应商:</label>
            <SupplierListSelect v-model='query.supplierId'/>
          </div>
          <div class="queryItem">
            <label>成本类型:</label>
            <lk-select v-model='query.payment' class="item">
              <lk-option v-for="(item, index) in paymentType" :key="index" :value="index+1">{{item}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button class="mr" @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
<div class="mb8">
<DownloadButton v-if="handlePermission('purchaseOrderDownloadBtn')" @on-click="handleExport"></DownloadButton>
</div>
        <lk-table border :columns='columns' :data='tableData'></lk-table>
      </div>
    </QueryFrame>

  </div>
</template>
<script>

import { mapGetters } from 'vuex';
import QueryFrame from '../../components/frame/QueryFrame.vue';
import purchase from '../../services/purchase';
// import utils from '../../libs/utils';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import SupplierListSelect from '../../components/SupplierListSelect.vue';

import DownloadButton from '../../components/download/DownloadButton.vue';

export default {
  name: 'orderList',
  components: {
    QueryFrame,
    SupplierListSelect,
    DownloadButton,
  },
  mixins: [mapState, queryMixins],
  computed: {
    // getNormalGoodsTypes() {
    //   return this.$store.state.publicParams.goodsTypes;
    // },
    ...mapGetters(['getNormalGoodsTypes', 'getGoodsOrigin']),
  },
  data() {
    return {
      query: {
        code: '',
        status: '',
        createUserName: '',
        createTimeStart: null,
        createTimeEnd: null,
        supplierID: '',
        payment: '',
        nameMix: '',
        goodsType: null, // 商品类型
        purchaseType: 1, // 来源
      },
      columns: [
        {
          title: '采购订单号', key: 'code', width: 190, fixed: 'left', tooltip: true,
        },
        {
          title: '供应商', key: 'supplierName', minWidth: 116, tooltip: true,
        },
        {
          title: '商品类型', key: 'goodsTypeName', width: 116, tooltip: true,
        },
        {
          title: '来源', key: 'purchaseTypeName', width: 116, tooltip: true,
        },
        { title: '成本类型', key: 'payment', minWidth: 116 },
        { title: '订单状态', key: 'status', minWidth: 116 },
        {
          title: '创建人', key: 'createUserName', minWidth: 116, tooltip: true,
        },
        { title: '创建时间', key: 'createTime', minWidth: 130 },
        {
          title: '取消原因', key: 'cancelReason', minWidth: 116, tooltip: true,
        },
        {
          title: '操作',
          key: 'operation',
          fixed: 'right',
          minWidth: 116,
          render: (h, params) => h('div', [
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({
                    name: 'orderInfo',
                    params: { purchaseOrderId: params.row.id, belongStore: params.row.storeId },
                  });
                },
              },
            }, '查看'),

          ]),
        },
      ],
      tableData: [],
      location: [],
      orderStatus: ['待发货', '已部分收货', '已全部收货', '已全部验收', '交易取消'],
      paymentType: ['普通', '寄售'],
    };
  },
  methods: {
    clear() {
      this.query = {
        code: '',
        status: '',
        createUserName: '',
        createTimeStart: null,
        createTimeEnd: null,
        supplierName: '',
        payment: '',
        storeIdList: [],
        goodsType: '',
        purchaseType: '',
      };
    },
    handleExport() {
      const params = Object.assign({}, this.query);
      // params.createTimeStart = params.createTimeStart && new Date(params.createTimeStart).getTime();
      // params.createTimeEnd = params.createTimeEnd && new Date(params.createTimeEnd).getTime();
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      purchase.orderListExport(params)
        .then((res) => {
          if (res.data.error) {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      // if (this.params.createTimeStart) {
      //   this.params.createTimeStart = (new Date(this.params.createTimeStart)).getTime();
      // }
      // if (this.params.createTimeEnd) {
      //   this.params.createTimeEnd = (new Date(this.params.createTimeEnd)).getTime();
      // }
      purchase.orderList(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            result.createTime = utils.formatTime(result.createTime, 'YYYY/MM/DD HH:mm');
            result.status = this.orderStatus[result.status - 1];
            result.payment = this.paymentType[result.payment - 1];
            result.accountPayable = utils.toFixed(result.accountPayable);
            console.log(result);
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
    if (this.roleType !== 2) {
      this.columns.splice(0, 0, {
        title: '门店名称', key: 'storeName', minWidth: 116, tooltip: true,
      });
    }
    this.handleSearch(true);
  },
};
</script>
<style lang="less" scoped>
.purchase-order-list{
  .query-item{
    display: flex;
    align-items: center;
    .query-label{
      margin-right: 10px;
    }
  }
  .search-btn{
    margin-right: 10px;
  }
  // .query-params-wrap{
  //   padding-bottom: 20px;
  // }
}
</style>
